import { render, staticRenderFns } from "./researchLab.vue?vue&type=template&id=45e47516&scoped=true&"
import script from "./researchLab.vue?vue&type=script&lang=js&"
export * from "./researchLab.vue?vue&type=script&lang=js&"
import style0 from "./researchLab.vue?vue&type=style&index=0&id=45e47516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e47516",
  null
  
)

export default component.exports